import { z } from "zod";

export const WordPressCredentialsSchema = z.object({
  username: z.string(),
  app_password_secret: z.string(),
});

/**
 * WordPress site document schema
 * Path: users/{userId}/integrations/wordpress/sites/{siteId}
 */
export const WordPressSiteSchema = z.object({
  site_id: z.string(),
  site_url: z.string(),
  site_name: z.string().default(""),
  status: z.string().default("connected"),
  credentials: WordPressCredentialsSchema,
});

export type WordPressSite = z.infer<typeof WordPressSiteSchema>;

export const parseWordPressSite = (data: unknown): WordPressSite =>
  WordPressSiteSchema.parse(data);

export const safeParseWordPressSite = (data: unknown) =>
  WordPressSiteSchema.safeParse(data);
